import React, { useContext } from "react";
import Breadcrumb from "../../components/Breadcrumb/Breadcrumb";
import CardHome from "../../components/CardHome/CardHome";
import PageTitle from "../../components/PageTitle/PageTitle";
import Slide from "../../components/Slide/Slide";
import { GlobalContext } from "../../contexts/GlobalContext";
import { primary, white, grayScale } from "./../../theme/colors";
import RegionServed from "../../components/RegionServed/RegionServed";
import CardProfile from "../../components/CardProfile/CardProfile";
import getImage from "../../useFull/getImage";

import LatestNews from "../../components/LatestNews/LatestNews";
import MainQuestions from "../../components/MainQuestions/MainQuestions";
// import dateWithMonth from '../../useFull/datePost';

const Home = () => {
  // const [dataCard, setDataCard] = useState([])

  // const getLastNotices = async () => {
  //     try {
  //         const resp = await axios.get(`http://localhost:1337/api/blogs?populate=*&sort[0]=createdAt:desc&pagination[limit]=3`);

  //         setDataCard(resp.data.data)
  //     } catch (error) {
  //         console.log(error);
  //     }
  // };

  // useEffect(() => {
  //     getLastNotices()
  // }, [])

  const { state } = useContext(GlobalContext);
  const language = state.language || "pt-br";
  const data = require(`../../assets/languages/${language}/home.json`);
  const {
    operationBase,
    structureOperationBase,
    operationBaseItens,
    cardsHome,
    regionServed,
    wareLocation,
    content,
    regionServedImg,
    transportProfile,
    whatTransport,
    transportContent,
    btnLabel,
    btnIcon,
    latestNews,
    contentCard,
  } = data;

  return (
    <>
      <Breadcrumb ignoreBreadcrumb={true} image={"principalbanner.png"} />

      <section>
        <div className="main-container bg-gray100">
          <div className="section-container card">
            {cardsHome.map((d, i) => (
              <CardHome
                key={i}
                iconName={d.imageIcon}
                title={d.title}
                content={d.content}
                imgName={d.image}
              />
            ))}
          </div>
        </div>
        <div className="main-container bg-primary100">
          <div className="section-container">
            <PageTitle
              title={operationBase}
              subtitle={structureOperationBase}
              secondaryColor={"var(--white100)"}
            />
          </div>
        </div>
        <div className="main-container bg-primary100">
          <Slide
            // autoPlay={true}
            // autoPlayDuration={1000}
            // isFade={true}
            // isCircle={true}
            data={operationBaseItens}
          />
        </div>

        <div className="main-container">
          <div className="section-container">
            <RegionServed
              title={regionServed}
              subtitle={wareLocation}
              content={content}
              image={regionServedImg[0].image}
            />
          </div>
        </div>
        <div
          className="main-container d-none"
          style={{
            backgroundImage: `url(${getImage("backgorund-profile", "perfil-carga-background.png")})`,
          }}
        >
          <div className="section-container">
            <CardProfile
              title={transportProfile}
              subtitle={whatTransport}
              content={transportContent}
              primaryColor={primary.primary300}
              secondaryColor={white}
              dividerColor={primary.primary300}
              label={btnLabel}
              iconName={btnIcon[0].image}
              textColor={primary.primary300}
              routeCard={`${language !== "pt-br" ? `/${language}` : "/load-profile"}`}
            />
          </div>
        </div>
        <div className="main-container mg-bot-70">
          <div className="section-container">
            <PageTitle title={latestNews} />
            <div className="card-news">
              {contentCard.map((d, i) => (
                <LatestNews
                  key={i}
                  image={d.image}
                  dateNews={d.dateNews}
                  titleCard={d.titleNews}
                  content={d.contentNews}
                  labelBtn={d.labelButton}
                  textColor={primary.primary300}
                  pathNotice={`${d.date}/${d.slug}`}
                />
              ))}
              {/* {
                                dataCard.length ? dataCard.map(({ attributes }, i) => (
                                    <LatestNews key={i}
                                        uriImage={`http://localhost:1337${attributes.coverImage.data.attributes.url}`}
                                        dateNews={dateWithMonth(attributes.publishedDate)}
                                        titleCard={attributes.title}
                                        content={attributes.content}
                                        labelBtn={'Saiba mais'} //Transformar numa const do arquivo de lang
                                        textColor={primary.primary300} />
                                )) : null} */}
            </div>
          </div>
        </div>
        <div className="main-container d-none">
          <div className="section-container main-questions">
            <PageTitle
              title={"Principais dúvidas"}
              _customClassName={"d-none"}
            />
            <MainQuestions
              textColor={primary.primary300}
              backgroundColorContent={white}
              contentColor={grayScale.gray300}
            />
          </div>
        </div>
      </section>
    </>
  );
};

export default Home;
